<template>
  <div flex="1">
    <div class="attractions-detail">
      <BaseAZError v-if="isError" />
      <template v-else>
        <div text="4xl" font="700" pt="5">
          {{ attrBasicInfo?.attrName }}
        </div>
        <div p="t-3" class="flex items-center justify-between gap-3">
          <div class="flex items-center">
            <van-rate
              readonly
              allow-half
              :model-value="parseFloat(attrBasicInfo?.rating || '')"
              :size="24"
              color="var(--tc-color-star)"
              void-color="#E3E3E3"
              void-icon="star"
            />
            <span style="color: var(--tc-color-star)" class="ml-3 text-5">{{ attrBasicInfo?.rating }}</span>
            <div v-if="attrBasicInfo?.cityName" class="ml-7.5 flex items-center gap-2.5 text-4">
              <div class="h-1.5 w-1.5 rounded-2 bg-#000"></div>
              {{ attrBasicInfo?.cityName }}
            </div>
            <div class="flex cursor-pointer gap-1" ml="4" :style="{ color: 'var(--tc-color-primary)' }" @click="getAttrDetail">
              <NuxtIcon name="material-symbols:info-outline" text="5"></NuxtIcon>
              <span class="underline">{{ t('key.attractions.detail.more.details') }}</span>
              <NuxtIcon name="material-symbols:chevron-right" text="5"></NuxtIcon>
            </div>
          </div>
        </div>
        <div class="pt-4.5 space-x-5" flex="~">
          <ElCarousel
            motion-blur
            class="flex-1 rounded-2.5"
            height="420px"
            indicator-color="white"
            :interval="3000"
            :autoplay="false"
          >
            <ElCarouselItem v-for="image in attrBasicInfo?.attrImgList" :key="image">
              <van-image :src="image" w="full" h="full" fit="cover" />
            </ElCarouselItem>
          </ElCarousel>
          <div v-if="attrBasicInfo?.lat && attrBasicInfo.lon" class="space-y-4" flex="~ col" w="70">
            <div b="1 solid #D9D9D9" rounded="2.5" overflow="hidden" flex="1 ~ col">
              <ClientOnly>
                <GoogleMap
                  class="relative h-full flex-1"
                  api-key="AIzaSyCFxLES2ohv41wiC8NWojKCdviMdUzEy64"
                  :center="{ lat: parseFloat(attrBasicInfo?.lat || ''), lng: parseFloat(attrBasicInfo?.lon || '') }"
                  :zoom="15"
                >
                  <Marker :options="{ position: { lat: parseFloat(attrBasicInfo?.lat || ''), lng: parseFloat(attrBasicInfo?.lon || '') } }" />
                </GoogleMap>
              </ClientOnly>
              <div p="t-3 b-4 x-2.5" flex="~ items-start">
                <img class="mr-2.5 w-6" src="~/assets/icons/icon_location_green.png" />
                <span text="base black" font="300" class="leading-5 underline">{{ attrBasicInfo?.address }}</span>
              </div>
            </div>
          </div>
        </div>
        <!-- <p class="mb-7 mt-4" v-html="attrDetail.data?.attrDesc">
      </p> -->
        <!-- 筛选条件 -->
        <div class="flex space-x-5" m="t-5 b-2.5">
          <div flex="shrink-0">
            <DesktopSelectDate class="mr-2 flex-1" :is-detail="true" :attr-name="attrBasicInfo?.attrName ?? ''">
              <template #default="{ formatDate }">
                <div
                  h="12"
                  flex="~ 1 items-center"
                  b="1 solid #00000014"
                  rounded="4.5"
                  bg="#F3F3F3"
                  p="x-6"
                >
                  <img :width="24" src="~assets/icons/icon-calendar.png" />
                  <div class="ml-2 text-lg text-[#121212]">
                    {{ formatDate }}
                  </div>
                </div>
              </template>
            </DesktopSelectDate>
          </div>
          <BusinessBSelectTicket :is-detail="true" :attr-name="attrBasicInfo?.attrName ?? ''" :page-type="E_RANK_TYPE.ATTRACTIONS">
            <template #default="{ checkedLabel }">
              <div
                class="absolute right-0 h-5 w-5 rounded-full bg-black text-center text-sm text-white leading-5 -top-1"
              >
                {{ filterConditionsStore.filterConditions.detailFilterIdList?.length || 0 }}
              </div>
              <div
                h="12"
                flex="~ 1 items-center"
                b="1 solid #00000014"
                rounded="4.5"
                bg="#F3F3F3"
                p="x-6"
                class="line-clamp-1"
              >
                <img :width="19" src="~assets/icons/icon-huge.png" />
                <div class="line-clamp-1 ml-2 text-lg text-[#121212]">
                  {{ checkedLabel }}
                </div>
              </div>
            </template>
          </BusinessBSelectTicket>
        </div>
        <BusinessBTicketOptions></BusinessBTicketOptions>
        <GroupedProduct />
      </template>
      <BaseAZDialog
        v-model="showPopup"
        align-center
        :title="t('key.attraction.detail.title')"
      >
        <div class="detail-content flex-1 overflow-y-auto" max-h="100" overflow-y="auto" v-html="attrDetail?.data?.attrDesc"></div>
      </BaseAZDialog>
      <ElDialog
        v-model="priceCalendarState.isShow"
        title="Select Date"
        :append-to-body="true" style="--el-dialog-width: min-content;"
        :destroy-on-close="true"
        center
      >
        <div min-h="100" min-w="232">
          <div v-if="priceCalendarState.loading" class="absolute left-1/2 top-1/2 -translate-x-1/2">
            <van-loading type="spinner" color="var(--tc-color-primary)" />
          </div>
          <DesktopPriceCalendar :attr-id="attrId" />
        </div>
      </ElDialog>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { GoogleMap, Marker } from 'vue3-google-map'
import GroupedProduct from './_components/GroupedProduct.vue'
import { E_RANK_TYPE } from '~/enums'

const {
  attrDetail,
  attrBasicInfo,
  showPopup,
  isError,
  attrId,
  getAttrDetail,
} = useAttractionDetail()

const filterConditionsStore = useFilterConditionsStore()
const { state: priceCalendarState } = usePriceCalendarState()

const { t } = useI18n()
</script>

<style lang="scss" scoped>
.attractions-detail {
  margin: 0 auto;
  width: 100%;
  max-width: 1240px;
  padding: 0 20px;

  :deep(.el-carousel__button) {
    border-radius: 100%;
    width: 8px;
    height: 8px;
    margin: 0 1px;
  }
}

.detail-content {
  :deep(img) {
    max-width: 100%;
  }
}
</style>
